import { t } from "i18next";
import DBModal from "../../../../component/global/DBModal";
import DBInput from "../../../../component/global/DBInput";
import DBModalTitle from "../../../../component/global/DbModalTitle";
import DBFieldBlock from "../../../../component/global/DBFieldBlock";
import TreeSearchSelect from "./../../../../component/global/TreeSearchSelect/index";
import DBSelect from "../../../../component/global/DBSelect";
import DBButton from "../../../../component/global/DBButton";
import DBTextArea from "../../../../component/global/DBTextArea";
import { useContext, useEffect, useState } from "react";
import { useRequest } from "../../../../hooks/helperData/useRequest";
import {
    SETTING_CERITERIA_LIST,
    SETTING_CRITERIA_TEMPLATE_LIST,
    SETTING_FORMS_CRITERIA,
} from "../../../../helperData/ApiAddress";
import DBSpinner from "../../../../component/global/DBSpinner";
import DBAddButton from "../../../../component/global/DBAddButton";
import { ToastContext } from "../../../../component/global/ToastContext";
import DBSwitch from "./../../../../component/global/DBSwitch/index";
import { getLanguageCaption } from "../../../../feedback/helperFunctions";
import DBAutoComplete from "../../../../component/global/DBAutoComplete";
import LanguageTable from "./LanguageTable";
import StateTable from "./StateTable";
import CriteriaStateModal from "./CriteriaStateModal";
import ConfirmModal from "../../../profile/ConfirmModal";
import AnswerTypeSelect from "../../../../modules/form-builder/AnswerTypeSelect";
import { resolveAnswerPresetId } from "../../../../modules/form-builder/answerTypes";

export default function CriteriaModal({
    show,
    onHide,
    onSuccess,
    editMode,
    itemType,
    selectedForm,
}) {
    const toast = useContext(ToastContext);

    const [form, setForm] = useState({
        criteria: {
            name: "",
            parent: null,
            translates: [],
        },
        criteria_state_type: "1",
        weight: "1",

        add_description: true,
        add_upload_file: true,
        upload_file_mandatory: false,
        upload_voice_mandatory: false,

        threshold_limit_count: "10",
        threshold_percent: "50",
        threshold_review_message: "",

        form: selectedForm?.id,
        states: {
            criteria_state_type: "2",
            states: [],
        },
    });

    const [formErr, setFormErr] = useState({
        name: "",
        weight: "",
        state: "",
        threshold_percent: "",
        threshold_limit_count: "",
    });

    const [sendCriteria, sendCriteriaLoader] = useRequest(
        SETTING_FORMS_CRITERIA + (editMode ? `${editMode}/` : ""),
        editMode ? "PUT" : "POST"
    );

    const [getCriteria, getCriteriaLoader] = useRequest(
        SETTING_FORMS_CRITERIA + editMode + "/",
        "GET"
    );

    const [getCriteriaList, getCriteriaListLoader] = useRequest(
        SETTING_CERITERIA_LIST,
        "GET"
    );

    const getCriteriaListHandle = () => {
        getCriteriaList().then((r) => {
            setCriteriaList(r);
        });
    };

    const [criteriaList, setCriteriaList] = useState([]);

    const [getCriteriaTemplateList, getCriteriaTemplateListLoader] = useRequest(
        SETTING_CRITERIA_TEMPLATE_LIST,
        "GET"
    );

    const [criteriaTemplateOptions, setCriteriaTemplateOptions] = useState([]);

    const getCriteriaTemplateListHandle = () => {
        getCriteriaTemplateList().then((r) => {
            setCriteriaTemplateOptions(r);
        });
    };

    useEffect(() => {
        if (show) {
            getCriteriaTemplateListHandle();
            getCriteriaListHandle();
            if (editMode) {
                getCriteria().then((r) => {
                    setForm({
                        criteria: {
                            ...r.criteria,
                            label: r.criteria.name,
                        },
                        criteria_state_type: r.criteria_state_type,
                        weight: r.weight + "",

                        add_description: r.add_description,
                        add_upload_file: r.add_upload_file,
                        upload_file_mandatory: r.upload_file_mandatory,
                        upload_voice_mandatory: r.upload_voice_mandatory,

                        threshold_limit_count: r.threshold_limit_count + "",
                        threshold_percent: r.threshold_percent + "",
                        threshold_review_message: r.threshold_review_message,

                        form: selectedForm?.id,
                        states: {
                            criteria_state_type: r.criteria_state_type,
                            states: r.states.map((item, index) => ({
                                id: index + 1,
                                ...item,
                            })),
                        },
                    });
                });
            } else {
                setForm({
                    criteria: {
                        name: "",
                        parent: null,
                        translates: [],
                    },
                    weight: "1",
                    criteria_state_type: "1",

                    add_description: true,
                    add_upload_file: true,
                    upload_file_mandatory: false,
                    upload_voice_mandatory: false,

                    threshold_limit_count: "10",
                    threshold_percent: "50",
                    threshold_review_message: "",

                    form: selectedForm?.id,
                    states: {
                        criteria_state_type: "2",
                        states: [],
                    },
                });
            }

            setFormErr({
                name: "",
                weight: "",
                state: "",
                threshold_percent: "",
                threshold_limit_count: "",
            });
        }
    }, [show]);

    const addEditCriteria = () => {
        let currectedFormData = { ...form };
        if (form.criteria.id) {
            currectedFormData.criteria = form.criteria.id;
        } else {
            currectedFormData.criteria = {
                name: form.criteria.name,
                translates: form.criteria.translates || [],
                parent: form.parent || form.criteria.parent || null,
            };
        }

        currectedFormData.states = (form.states?.states || []).map((state) => ({
            name: state.name,
            emoji: state.emoji || "",
            value: state.value,
            translates: state.translates || [],
        }));

        let formErrTemp = {};
        if (
            typeof currectedFormData.criteria !== "number" &&
            !currectedFormData.criteria.name.trim()
        ) {
            formErrTemp.name = t("criteria.name.required");
        }

        if (!currectedFormData.weight.trim()) {
            formErrTemp.weight = t("criteria.weight.required");
        }

        if (currectedFormData.states.length < 2) {
            formErrTemp.state = t("criteria.state.required");
        }

        if (!currectedFormData.threshold_percent.trim()) {
            formErrTemp.threshold_percent = t(
                "criteria.threshold.percent.required"
            );
        }

        if (!currectedFormData.threshold_limit_count.trim()) {
            formErrTemp.threshold_limit_count = t(
                "criteria.threshold.limit.count.required"
            );
        }

        setFormErr(formErrTemp);

        if (Object.keys(formErrTemp).length > 0) return false;

        sendCriteria(currectedFormData)
            .then((r) => {
                onHide?.();
                onSuccess?.();
                toast(t("criteria.save.success"), "success");
            })
            .catch((e) => {
                toast(t("criteria.save.error"), "danger");
            });
    };

    const [language, setLanguage] = useState({
        name: "",
        description: "",
        language: "en",
    });
    const [languageEditMode, setLanguageEditMode] = useState(false);

    const addLanguageHandle = () => {
        if (languageEditMode !== false) {
            setForm({
                ...form,
                criteria: {
                    ...form.criteria,
                    translates: form.criteria.translates.map((item, index) =>
                        index === languageEditMode ? language : item
                    ),
                },
            });
            setLanguageEditMode(false);
            setLanguage({
                name: "",
                description: "",
                language: "en",
            });
        } else {
            if (
                !form.criteria.translates.some(
                    (item) => item.language === language.language
                )
            ) {
                setForm({
                    ...form,
                    criteria: {
                        ...form.criteria,
                        translates: [...form.criteria.translates, language],
                    },
                });
                setLanguage({
                    name: "",
                    description: "",
                    language: "en",
                });
            }
        }
    };

    const deleteLanguageHandle = (index) => {
        setForm({
            ...form,
            criteria: {
                ...form.criteria,
                translates: form.criteria.translates.filter(
                    (_, ind) => ind !== index
                ),
            },
        });
    };

    const editLanguageHandle = (index) => {
        setLanguage(form.criteria.translates.find((_, ind) => ind === index));
        setLanguageEditMode(index);
    };

    const [criteriaStateModalShow, setCriteriaStateModalShow] = useState(false);
    const [criteriaStateEditMode, setCriteriaStateEditMode] = useState(false);
    const [stateDeleteConfirmationModal, setStateDeleteConfirmationModal] =
        useState(false);
    const [stateDeleteConfirmationIndex, setStateDeleteConfirmationIndex] =
        useState(false);

    return (
        <>
            <div className="criteria-state-modal-con">
                <ConfirmModal
                    show={stateDeleteConfirmationModal}
                    onHide={() => setStateDeleteConfirmationModal(false)}
                    btnTitle={t("criteria.state.delete.yes")}
                    title={t("criteria.state.delete.title")}
                    description={t("criteria.state.delete.description")}
                    onConfirm={() => {
                        setForm({
                            ...form,
                            states: {
                                ...form.states,
                                states: form.states?.states
                                    ?.sort((a, b) => a.value - b.value)
                                    .filter(
                                        (_, ind) =>
                                            ind !== stateDeleteConfirmationIndex
                                    ),
                            },
                        });
                        setStateDeleteConfirmationModal(false);
                    }}
                />
                <CriteriaStateModal
                    show={criteriaStateModalShow}
                    onHide={() => setCriteriaStateModalShow(false)}
                    editMode={criteriaStateEditMode}
                    onSuccess={(state) => {
                        if (criteriaStateEditMode) {
                            setForm({
                                ...form,
                                states: {
                                    ...form.states,
                                    states: [
                                        ...form.states.states.filter(
                                            (item) => item.id !== state.id
                                        ),
                                        state,
                                    ],
                                },
                            });
                        } else {
                            setForm({
                                ...form,
                                states: {
                                    ...form.states,
                                    states: [
                                        ...form.states.states,
                                        {
                                            ...state,
                                            id: form.states.states.length,
                                        },
                                    ],
                                },
                            });
                        }
                    }}
                    stateType={form.states?.criteria_state_type}
                />
            </div>
            <DBModal
                permanent
                show={show}
                minWidth={560}
                onHide={onHide}
                className="criteria-modal"
            >
                <DBModal.Header
                    closeBtn={onHide}
                    title={
                        <div>
                            {t("criteria.modal.header")}
                            <div className="header-subcat">
                                {t("criteria.modal.subheader")} {itemType?.name}{" "}
                                {t("form.caption.in.header")}{" "}
                                {selectedForm?.name}{" "}
                            </div>
                        </div>
                    }
                />

                <DBModal.Content>
                    {getCriteriaLoader ||
                    getCriteriaListLoader ||
                    getCriteriaTemplateListLoader ? (
                        <DBSpinner tip={t("loading")} />
                    ) : (
                        <>
                            <DBModalTitle>
                                {t("item.type.main.fields")}
                            </DBModalTitle>
                            <div className="grid">
                                <DBFieldBlock
                                    title={t("criteria.modal.name")}
                                    required
                                    error={formErr.name}
                                >
                                    <DBAutoComplete
                                        status={formErr.name && "error"}
                                        onClick={() => {
                                            setFormErr({
                                                ...formErr,
                                                name: "",
                                            });
                                        }}
                                        onLock={(caption, option) => {
                                            let temp = { ...form.criteria };
                                            temp = option;
                                            setForm({
                                                ...form,
                                                criteria: {
                                                    ...form.criteria,
                                                    ...temp,
                                                },
                                            });
                                        }}
                                        onChange={(caption, option) => {
                                            let temp = { ...form.criteria };

                                            if (option.value) {
                                                temp = option;
                                            } else {
                                                temp = {
                                                    name: caption,
                                                    label: caption,
                                                    value: caption,
                                                    id: undefined,
                                                };
                                            }
                                            setForm({
                                                ...form,
                                                criteria: {
                                                    ...form.criteria,
                                                    ...temp,
                                                },
                                            });
                                        }}
                                        value={form.criteria.label}
                                        options={criteriaList.map((item) => ({
                                            value: item.name + item.id,
                                            label: item.name,
                                            id: item.id,
                                        }))}
                                    />
                                </DBFieldBlock>
                                <DBFieldBlock title={t("items.parent")}>
                                    <TreeSearchSelect
                                        data={criteriaList}
                                        size="large"
                                        disabled={form.criteria?.id}
                                        value={form.parent}
                                        onChange={(e) => {
                                            setForm({
                                                ...form,
                                                parent: e,
                                            });
                                        }}
                                    />
                                </DBFieldBlock>
                                <DBFieldBlock
                                    title={t("criteria.modal.weight")}
                                    required
                                    error={formErr.weight}
                                >
                                    <DBInput
                                        onClick={() =>
                                            setFormErr({
                                                ...formErr,
                                                weight: "",
                                            })
                                        }
                                        status={formErr.weight && "error"}
                                        type="number"
                                        min="1"
                                        size="large"
                                        value={form.weight}
                                        onChange={(e) =>
                                            setForm({
                                                ...form,
                                                weight: e.target.value,
                                            })
                                        }
                                    />
                                </DBFieldBlock>
                            </div>
                            <DBModalTitle>
                                {t("criteria.modal.states.title")}
                            </DBModalTitle>
                            <div className="grid">
                                <DBFieldBlock
                                    title={t("criteria.modal.state.select")}
                                    span={2}
                                    error={formErr.state}
                                >
                                    <AnswerTypeSelect
                                        extraOptions={criteriaTemplateOptions}
                                        value={
                                            form.states?.id ??
                                            (form.states?.states?.length
                                                ? resolveAnswerPresetId({
                                                      criteria_state_type:
                                                          form.criteria_state_type,
                                                      states: form.states
                                                          ?.states,
                                                  })
                                                : undefined)
                                        }
                                        status={formErr.state && "error"}
                                        onClick={() =>
                                            setFormErr({
                                                ...formErr,
                                                state: "",
                                            })
                                        }
                                        onChange={(preset) => {
                                            setForm({
                                                ...form,
                                                states: {
                                                    id: preset.id,
                                                    name: preset.name,
                                                    criteria_state_type:
                                                        preset.criteria_state_type,
                                                    states: preset.states.map(
                                                        (item, index) => ({
                                                            ...item,
                                                            id: index,
                                                        })
                                                    ),
                                                },
                                                criteria_state_type:
                                                    preset.criteria_state_type,
                                            });
                                        }}
                                    />
                                </DBFieldBlock>
                            </div>
                            <div className="criteria-states-table">
                                {form.states?.states?.length > 0 && (
                                    <StateTable
                                        data={form.states}
                                        onEdit={(index) => {
                                            setCriteriaStateEditMode(
                                                form.states?.states
                                                    ?.sort(
                                                        (a, b) =>
                                                            a.value - b.value
                                                    )
                                                    .find(
                                                        (_, ind) =>
                                                            ind === index
                                                    )
                                            );
                                            setCriteriaStateModalShow(true);
                                        }}
                                        onDelete={(index) => {
                                            setStateDeleteConfirmationModal(
                                                true
                                            );
                                            setStateDeleteConfirmationIndex(
                                                index
                                            );
                                        }}
                                    />
                                )}
                            </div>
                            <div>
                                <DBButton
                                    disabled={!form.states?.states}
                                    caption={t("criteria.state.add")}
                                    className="fullwidth-button"
                                    outlined
                                    onClick={() => {
                                        setFormErr({
                                            ...formErr,
                                            state: "",
                                        });
                                        setCriteriaStateModalShow(true);
                                        setCriteriaStateEditMode(false);
                                    }}
                                />
                            </div>
                            <DBModalTitle>
                                {t("criteria.modal.max.title")}
                            </DBModalTitle>
                            <div className="grid">
                                <DBFieldBlock
                                    title={t("criteria.modal.max")}
                                    error={formErr.threshold_percent}
                                >
                                    <DBInput
                                        status={
                                            formErr.threshold_percent && "error"
                                        }
                                        onClick={() =>
                                            setFormErr({
                                                ...formErr,
                                                threshold_percent: "",
                                            })
                                        }
                                        type="number"
                                        size="large"
                                        value={form.threshold_percent}
                                        onChange={(e) =>
                                            setForm({
                                                ...form,
                                                threshold_percent:
                                                    e.target.value,
                                            })
                                        }
                                    />
                                </DBFieldBlock>
                                <DBFieldBlock
                                    title={t("criteria.modal.max.number")}
                                    error={formErr.threshold_limit_count}
                                >
                                    <DBInput
                                        status={
                                            formErr.threshold_limit_count &&
                                            "error"
                                        }
                                        onClick={() =>
                                            setFormErr({
                                                ...formErr,
                                                threshold_limit_count: "",
                                            })
                                        }
                                        type="number"
                                        size="large"
                                        value={form.threshold_limit_count}
                                        onChange={(e) =>
                                            setForm({
                                                ...form,
                                                threshold_limit_count:
                                                    e.target.value,
                                            })
                                        }
                                    />
                                </DBFieldBlock>
                                <DBFieldBlock
                                    title={t("criteria.modal.max.message")}
                                    span={2}
                                >
                                    <DBTextArea
                                        rows={4}
                                        type="text"
                                        size="large"
                                        value={form.threshold_review_message}
                                        onChange={(e) =>
                                            setForm({
                                                ...form,
                                                threshold_review_message:
                                                    e.target.value,
                                            })
                                        }
                                    />
                                </DBFieldBlock>
                            </div>
                            {!form.criteria.id && (
                                <>
                                    <DBModalTitle>
                                        {t("items.language")}
                                    </DBModalTitle>
                                    <div className="grid">
                                        <DBFieldBlock
                                            title={t("criteria.modal.name")}
                                        >
                                            <DBInput
                                                type="text"
                                                size="large"
                                                value={language.name}
                                                onChange={(e) =>
                                                    setLanguage({
                                                        ...language,
                                                        name: e.target.value,
                                                    })
                                                }
                                            />
                                        </DBFieldBlock>

                                        <DBFieldBlock
                                            title={t(
                                                "criteria.modal.name.language"
                                            )}
                                        >
                                            <DBSelect
                                                value={language.language}
                                                onChange={(e) =>
                                                    setLanguage({
                                                        ...language,
                                                        language: e,
                                                    })
                                                }
                                                options={[
                                                    {
                                                        value: "en",
                                                        label: getLanguageCaption(
                                                            "en"
                                                        ),
                                                    },
                                                    {
                                                        value: "ar",
                                                        label: getLanguageCaption(
                                                            "ar"
                                                        ),
                                                    },
                                                ]}
                                                size="large"
                                            />
                                        </DBFieldBlock>

                                        <DBFieldBlock title="" span={2}>
                                            <DBButton
                                                disabled={!language.name.trim()}
                                                caption={
                                                    languageEditMode === false
                                                        ? t(
                                                              "items.add.language"
                                                          )
                                                        : t(
                                                              "items.edit.language"
                                                          )
                                                }
                                                className="fullwidth-button"
                                                outlined
                                                onClick={addLanguageHandle}
                                            />
                                        </DBFieldBlock>
                                    </div>
                                    {form.criteria.translates.length > 0 && (
                                        <div className="language-table">
                                            <LanguageTable
                                                data={form.criteria.translates?.map(
                                                    (item) => ({
                                                        ...item,
                                                        language:
                                                            item.language ===
                                                            "en"
                                                                ? t(
                                                                      "item.type.language.en"
                                                                  )
                                                                : t(
                                                                      "item.type.language.ar"
                                                                  ),
                                                    })
                                                )}
                                                onEdit={editLanguageHandle}
                                                onDelete={deleteLanguageHandle}
                                            />
                                        </div>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </DBModal.Content>
                <DBModal.Footer>
                    <DBButton
                        caption={t("save")}
                        onClick={addEditCriteria}
                        loading={sendCriteriaLoader}
                    />
                    <DBButton
                        caption={t("cancel")}
                        type="secondary"
                        onClick={onHide}
                    />
                </DBModal.Footer>
            </DBModal>
        </>
    );
}
